<div>
    @if (metricsLoadError) {
        <div class="alert alert-warning py-2 small" role="alert">Dashboard metrics could not be loaded. Try refreshing the page.</div>
    }

    <div class="row g-3 mb-3">
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-primary border-opacity-25">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Total reports</div>
                    <div class="fs-3 fw-semibold">{{ metrics.kpi.totalReports }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-primary border-opacity-25">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Last 30 days</div>
                    <div class="fs-3 fw-semibold">{{ metrics.kpi.reportsLast30Days }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-danger border-opacity-50">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">With injuries (30d)</div>
                    <div class="fs-3 fw-semibold text-danger">{{ metrics.kpi.injuryInvolvedCount }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card h-100 border-warning border-opacity-50">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Open confined space</div>
                    <div class="fs-3 fw-semibold">{{ metrics.kpi.openConfinedSpacePermits }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-3">
        <div class="col-lg-6">
            <div class="card h-100">
                <div class="card-body">
                    <h5 class="card-title">Reports by month</h5>
                    <p class="small text-muted">Checklist reports over the last 6 months.</p>
                    @if (metrics.monthlyCounts.length === 0) {
                        <p class="text-muted small mb-0">No reports in this period.</p>
                    } @else {
                        <div class="d-flex align-items-end gap-1 scl-bar-wrap">
                            @for (m of metrics.monthlyCounts; track m.label) {
                                <div class="flex-fill text-center">
                                    <div
                                        class="scl-bar rounded-top"
                                        [style.height.px]="(m.count / maxMonthlyCount()) * 120 || 4"
                                        [title]="m.label + ': ' + m.count"
                                    ></div>
                                    <div class="small text-muted mt-1">{{ m.label }}</div>
                                    <div class="small fw-semibold">{{ m.count }}</div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="card h-100">
                <div class="card-body">
                    <h5 class="card-title">Last 30 days by form type</h5>
                    <p class="small text-muted">Counts for each implemented checklist form.</p>
                    <ul class="list-unstyled mb-0">
                        @for (item of metrics.last30DaysByFormType; track item.formType) {
                            <li class="d-flex justify-content-between border-bottom py-1">
                                <span>{{ item.formType }}</span>
                                <span class="fw-semibold">{{ item.count }}</span>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
